/*
  Membership gift housekeeping.
  The water shop adds the gift products (line property _membership_gift) together with a
  subscription. If the subscription line later leaves the cart (removed in the drawer, or its
  quantity set to 0) the gift lines would be charged at full price, so they are removed too.
  The cart markup (snippets/cart-products.liquid) exposes data-cart-has-subscription on the
  wrapper and data-gift-line + data-key on each gift row; Horizon re-renders that markup on
  every cart:update, and this script re-checks after each one.
*/
(function () {
  var busy = false;

  function routes() {
    return (window.Theme && window.Theme.routes) || {};
  }

  function check() {
    if (busy) return;
    var wrapper = document.querySelector('[data-cart-has-subscription]');
    if (!wrapper) return;
    if (wrapper.getAttribute('data-cart-has-subscription') === 'true') return;
    var rows = wrapper.querySelectorAll('[data-gift-line][data-key]');
    if (!rows.length) return;

    var updates = {};
    rows.forEach(function (row) { updates[row.getAttribute('data-key')] = 0; });

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId && sectionIds.indexOf(c.dataset.sectionId) === -1) sectionIds.push(c.dataset.sectionId);
    });

    busy = true;
    fetch(routes().cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.status) return;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'membership-gift',
            data: { source: 'membership-gift', itemCount: cart.item_count, sections: cart.sections || {} }
          }
        }));
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  document.addEventListener('cart:update', function () { setTimeout(check, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
